import { installBenignDevErrorSuppression } from './utils/suppressBenignDevErrors';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config';
import './styles/App.css';
import './styles/animations.css';
import { FEATURE_FLAGS } from './config/featureFlags';

// Brand-aware entry. chefkunming is a focused catering-only site with a much
// smaller bundle. We key the selection off the BUILD-TIME env flag directly
// (webpack inlines REACT_APP_SITE_BRAND), so Terser folds this to a constant
// and tree-shakes the unused app out completely — for the chefkunming build the
// full MGV App is never even bundled.
import CateringApp from './CateringApp';
const FullApp = lazy(() => import('./App'));
const IS_CATERING_SITE = process.env.REACT_APP_SITE_BRAND === 'chefkunming';
const App = IS_CATERING_SITE ? CateringApp : FullApp;

installBenignDevErrorSuppression();

// ── Global error hooks (prod only, deferred import) ──────────────
if (process.env.NODE_ENV === 'production') {
  requestIdleCallback(() => {
    import('./utils/clientLogger').then(({ default: clientLogger }) => {
      window.onerror = (msg, source, line, col, error) => {
        clientLogger.logError(error || new Error(String(msg)), {
          component: 'global', action: 'window.onerror', source, line, col,
        });
      };
      window.onunhandledrejection = (event) => {
        clientLogger.logError(event.reason, {
          component: 'global', action: 'unhandledrejection',
        });
      };
    }).catch(() => {});
  }, { timeout: 5000 });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }} aria-hidden="true">Loading…</div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// Register Service Worker for hospitality menu offline support
if ('serviceWorker' in navigator && FEATURE_FLAGS.SERVICE_WORKER && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // SW registration failed silently — app still functions without offline mode
    });
  });
} 